<template>
  <div class="pt-4">
    <CustomButton
      type="button"
      class="mb-4"
      variant="outlined"
      :busy="loading"
      @click="check"
    >
      {{ $t('filter.check') }}
    </CustomButton>
    <div v-if="warning" class="text-red-120 mb-3">
      {{ warning }}
    </div>
    <div v-if="checkedNumber != null">
      {{ `${label}: ${checkedNumber ?? ''}` }}
    </div>
    <div v-else-if="checkedNumberArray != null">
      <div>
        {{ `${label}:` }}
      </div>
      <div v-for="(item, index) in checkedNumberArray" :key="item.id">
        <template v-if="licenseMode">
          {{ `${item.number ?? ''} (${$t('licenses.license')} ${index+1})` }}
        </template>
        <template v-else>
          {{ `${item.number ?? ''} (Kampagne ${index+1})` }}
        </template>
      </div>
      <div v-if="total != null">
        {{ `${$t('filter.total')}: ${total}` }}
      </div>
    </div>
    <div v-else-if="error != null" class="text-red-120">
      {{ error }}
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, watch } from 'vue';
import CustomButton from '@utils/CustomButton.vue';
import { useCheckFilter } from '@hooks/check-filter';
import type {
  Filter, MaybeHydra,
} from '@/entities/Entities';

interface Props {
  filter: Filter;
  route: string;
  label: string;
  warning?: string;
  validationFunction?: ((data: MaybeHydra<Filter>) => boolean) | undefined;
  additionalPayload?: object;
  licenseMode?: boolean
}

const props = defineProps<Props>();

const emit = defineEmits(['update:warning']);

const {
  checkFilter,
  checkedNumber,
  checkedNumberArray,
  error,
  loading,
} = useCheckFilter(
  props.route,
  props.filter,
);

const check = () => {
  checkFilter(props.validationFunction, props.additionalPayload);
};

const total = computed(() => {
  if (checkedNumberArray.value !== undefined) {
    return checkedNumberArray.value.reduce((acc, item) => acc + (item.number ?? 0), 0);
  }
  return null;
});

watch(() => props.filter, () => {
  emit('update:warning');
}, { deep: true });

watch(() => props.additionalPayload, () => {
  emit('update:warning');
}, { deep: true });
</script>

<style lang="scss" scoped></style>
